import { defineMessages } from 'react-intl';

export const footerFirstdata = defineMessages({
    title: {
        id: 'footer.logos.firstdata.title',
        description: 'firstdata logo html title',
        defaultMessage: 'First Data'
    }
});

export default footerFirstdata;
